import { render } from "./AllBuyAndSellP.vue?vue&type=template&id=ad2aa430&scoped=true"
import script from "./AllBuyAndSellP.vue?vue&type=script&lang=js"
export * from "./AllBuyAndSellP.vue?vue&type=script&lang=js"

import "./AllBuyAndSellP.vue?vue&type=style&index=0&id=ad2aa430&lang=scss&scoped=true"

import exportComponent from "C:\\inetpub\\wwwroot\\hesabtech-live\\hesabtech-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ad2aa430"]])

export default __exports__